import { crewsAPI } from '../services/api';
import { useNotifications } from '../components/notifications';

/**
 * Hook for mobile-friendly crew operations using dropdowns
 */
export const useMobileCrewOperations = (selectedCrew, setSelectedCrew, crews, setCrews) => {
  const { showToast } = useNotifications();

  const handleAssignRowerToSeat = async (rowerId, seatNumber) => {
    if (!selectedCrew || !rowerId) return;

    try {
      const memberData = {
        user_id: rowerId,
      };

      // Add seat_number if it's a valid seat (not general crew drop)
      if (typeof seatNumber === 'number') {
        memberData.seat_number = seatNumber;
      }

      // Call API to add member to crew
      await crewsAPI.addCrewMember(selectedCrew.id, memberData);

      // Refresh crew data
      const updatedCrew = await crewsAPI.getCrew(selectedCrew.id);

      setSelectedCrew(updatedCrew);
      setCrews(crews.map((crew) => (crew.id === selectedCrew.id ? updatedCrew : crew)));
      showToast('Rower assigned successfully', 'success');
    } catch (error) {
      console.error('Assignment error:', error);
      showToast('Failed to assign rower', 'error');
    }
  };

  const handleRemoveMember = async (memberId) => {
    if (!selectedCrew) return;

    try {
      await crewsAPI.removeCrewMember(selectedCrew.id, memberId);

      // Refresh crew data
      const updatedCrew = await crewsAPI.getCrew(selectedCrew.id);

      setSelectedCrew(updatedCrew);
      setCrews(crews.map((crew) => (crew.id === selectedCrew.id ? updatedCrew : crew)));
      showToast('Rower removed successfully', 'success');
    } catch (error) {
      showToast('Failed to remove rower', 'error');
    }
  };

  const handleChangeSeatAssignment = async (userId, newSeatNumber) => {
    if (!selectedCrew || !userId) return;

    try {
      // Find the member by user ID to get the member ID for removal
      const member = selectedCrew.members.find((m) => m.user?.id === userId);
      if (!member) {
        showToast('Member not found in crew', 'error');
        return;
      }

      // First remove the current member
      await crewsAPI.removeCrewMember(selectedCrew.id, member.id);

      // Then add them back with the new seat
      const memberData = {
        user_id: userId,
      };

      if (typeof newSeatNumber === 'number') {
        memberData.seat_number = newSeatNumber;
      }

      await crewsAPI.addCrewMember(selectedCrew.id, memberData);

      // Refresh crew data
      const updatedCrew = await crewsAPI.getCrew(selectedCrew.id);
      setSelectedCrew(updatedCrew);
      setCrews(crews.map((crew) => (crew.id === selectedCrew.id ? updatedCrew : crew)));
      showToast('Seat assignment updated successfully', 'success');
    } catch (error) {
      console.error('Seat change error:', error);
      showToast('Failed to update seat assignment', 'error');
    }
  };

  return {
    handleAssignRowerToSeat,
    handleRemoveMember,
    handleChangeSeatAssignment,
  };
};

export default useMobileCrewOperations;
